"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerNextFrame = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PlayerNextFrame = function PlayerNextFrame(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.0156 6.03125C9.79688 6.03125 7.90625 6.8125 6.34375 8.375C4.78125 9.9375 4 11.8125 4 14C4 16.2188 4.79688 18.1094 6.39062 19.6719C7.95312 21.2344 9.82812 22.0156 12.0156 22.0156C14.2031 22.0156 16.0938 21.2344 17.6875 19.6719C19.25 18.1094 20.0312 16.2188 20.0312 14H18.0156C18.0156 15.6562 17.4375 17.0781 16.2812 18.2656C15.0938 19.4219 13.6719 20 12.0156 20C10.3594 20 8.95312 19.4219 7.79688 18.2656C6.60938 17.0781 6.01562 15.6562 6.01562 14C6.01562 12.3438 6.60938 10.9375 7.79688 9.78125C8.95312 8.59375 10.3594 8 12.0156 8V12.0312L17.0312 7.01562L12.0156 2V6.03125Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.7285 17.0156H11.7383V13.8633L10.7656 14.1475V13.3975L12.6377 12.75H12.7285V17.0156Z"
  }));
};
exports.PlayerNextFrame = PlayerNextFrame;